document.addEventListener("DOMContentLoaded", function () {
  initializeQuantityButtons();

  // Add event listeners for add to cart forms
  initializeAddToCartForms();
});

function initializeQuantityButtons(root = document) {
  root.querySelectorAll(".qty-btn").forEach((button) => {
    if (button.hasAttribute("data-quantity-listener")) return;
    button.setAttribute("data-quantity-listener", "true");
    button.addEventListener("click", function () {
      const input = button.closest("form")?.querySelector(".qty-input-box");
      if (!input) return;
      const value = Number(input.value);
      const minimum = Number(input.min) || 1;
      const maximum = input.max === "" ? Number.POSITIVE_INFINITY : Number(input.max);
      if (button.classList.contains("minus") && value > minimum) input.value = value - 1;
      if (button.classList.contains("plus") && value < maximum) input.value = value + 1;
    });
  });
}

function preventZoom(event) {
  event.preventDefault();
}

function initializeAddToCartForms() {
  // Select all add to cart forms with comprehensive selectors
  const addToCartForms = Array.from(
    document.querySelectorAll('form:not(#product-form)[action*="/cart/add"], form:not(#product-form).product-form, .collection-product-card form:not(#product-form)')
  ).filter((form) => !form.closest(".product-card"));
  
  addToCartForms.forEach((form) => {
    // Check if we already added our custom listener
    if (form.hasAttribute('data-custom-cart-listener')) {
      return; // Skip if already processed
    }
    // Mark this form as processed
    form.setAttribute('data-custom-cart-listener', 'true');
    
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      
      // Double check to avoid multiple submissions
      if (form.hasAttribute('data-submitting') || form.dataset.cartUncertain === 'true') {
        return;
      }
      form.setAttribute('data-submitting', 'true');
      
      const qtyInput = form.querySelector(".qty-input-box");
      const quantity = qtyInput ? Number(qtyInput.value) : 1;
      const inventoryLimited = form.dataset.inventoryLimited === "true";
      const status = form.querySelector(".cart-add-status");
      const cartButton = form.querySelector('[type="submit"]');
      const cartButtonText = form.querySelector(".cartbtn-text");
      clearTimeout(form.cartFeedbackTimer);
      const originalButtonText = "Add to Cart";
      const originalButtonDisabled = cartButton?.disabled ?? false;
      let addedToCart = false;
      let remainingAfterAdd = null;

      // Only enforce a local quantity ceiling when Shopify tracks finite inventory.
      let currentRealQty = null;
      const card = form.closest(".collection-product-card");
      const selector = card?.querySelector(".variant-selector");
      const selectorWasDisabled = selector?.disabled ?? false;
      const cardRealQty = card?.querySelector(".real-qty");
      if (inventoryLimited && cardRealQty) {
        currentRealQty = Number.parseInt(cardRealQty.textContent, 10);
      }

      if (!Number.isSafeInteger(quantity) || quantity < 1 ||
          (inventoryLimited && (!Number.isFinite(currentRealQty) || quantity > currentRealQty))) {
        const message = inventoryLimited
          ? "所選款式庫存不足，請調整數量後再試。"
          : "請輸入有效的商品數量。";
        if (status) status.textContent = message;
        else alert(message);
        form.removeAttribute('data-submitting');
        return false;
      }

      if (cartButton) cartButton.disabled = true;
      if (selector) selector.disabled = true;
      if (cartButtonText) cartButtonText.textContent = "加入中…";
      if (status) status.textContent = "";

      const formData = new FormData(form);
      formData.set("quantity", quantity);
      
      try {
        const addUrl = form.dataset.cartAddUrl || `${form.action.replace(/\/$/, "")}.js`;
        const responseData = await window.StickyCart.addCartItem(addUrl, {
          method: "POST",
          body: formData,
        });
        
        addedToCart = true;
        const cartQuantity = Number.isSafeInteger(responseData?.quantity)
          ? responseData.quantity
          : Number(form.dataset.cartQuantity || 0) + quantity;
        form.dataset.cartQuantity = String(cartQuantity);
        const selectedOption = selector?.options[selector.selectedIndex];
        if (selectedOption) selectedOption.dataset.cartQuantity = String(cartQuantity);
        if (inventoryLimited && card && cardRealQty) {
          remainingAfterAdd = Math.max(currentRealQty - quantity, 0);
          cardRealQty.textContent = remainingAfterAdd;
          const stock = card.querySelector("[data-variant-stock]");
          if (stock) stock.textContent = `庫存：${remainingAfterAdd}`;
          if (qtyInput) {
            qtyInput.max = Math.max(remainingAfterAdd, 1);
            qtyInput.value = Math.min(quantity, Math.max(remainingAfterAdd, 1));
          }
        }

        if (status) status.textContent = "已加入購物車。";
        try {
          if (document.querySelector(".sticky-cart") && window.StickyCart?.updateCartDrawer) {
            if (await window.StickyCart.updateCartDrawer() === false) throw new Error("Cart refresh failed");
          } else if (window.StickyCart?.updateCartSummary) {
            await window.StickyCart.updateCartSummary();
          } else if (form.dataset.cartUrl) {
            const cartResponse = await fetch(form.dataset.cartUrl);
            if (!cartResponse.ok) throw new Error(`Cart refresh failed with HTTP ${cartResponse.status}`);
            const cartData = await cartResponse.json();
            document.querySelectorAll(".cart-count").forEach(el => { el.textContent = cartData.item_count; });
          }
        } catch (error) {
          console.error("Unable to refresh the cart after adding an item:", error);
          const message = "已加入購物車，但數量顯示未能更新，請重新載入頁面核對。";
          if (status) status.textContent = message;
          else alert(message);
        }

        initializeAddToCartForms();
      } catch (err) {
        if (err.cartUncertain) form.dataset.cartUncertain = 'true';
        console.error("Fetch error:", err);
        const message = err.message || "加入購物車失敗，請檢查網絡後再試。";
        if (status) status.textContent = message;
        else alert(message);
      } finally {
        form.removeAttribute('data-submitting');
        if (selector) selector.disabled = selectorWasDisabled || form.dataset.cartUncertain === 'true';
        if (cartButton) {
          cartButton.disabled = addedToCart
            ? inventoryLimited && remainingAfterAdd < 1
            : originalButtonDisabled || form.dataset.cartUncertain === 'true';
          cartButton.classList.toggle("disable-CartBtn", cartButton.disabled);
          cartButton.classList.toggle("CartBtn", !cartButton.disabled);
          form.querySelectorAll(".qty-btn, .qty-input-box").forEach(control => {
            control.disabled = cartButton.disabled;
          });
          if (qtyInput) {
            qtyInput.min = cartButton.disabled ? 0 : 1;
            if (cartButton.disabled) qtyInput.value = 0;
          }
        }
        if (cartButtonText) {
          const defaultText = form.dataset.cartUncertain === 'true' ? "請先核對購物車" : cartButton?.disabled ? "Sold Out" : originalButtonText;
          cartButtonText.textContent = addedToCart ? `✓ ${form.dataset.cartQuantity} in Cart` : defaultText;
          if (addedToCart) {
            form.cartFeedbackTimer = setTimeout(() => {
              cartButtonText.textContent = defaultText;
            }, 2000);
          }
        }
      }
    });
  });
}

function updateSelectedCardVariant(selector) {
  const option = selector.options[selector.selectedIndex];
  const card = selector.closest(".collection-product-card");
  if (!card || !option) {
    return;
  }

  const form = card.querySelector(".product-form");
  const variantId = form && form.querySelector('input[name="id"]');
  const qtyInput = card.querySelector(".qty-input-box");
  const addButton = card.querySelector(".CartBtn, .disable-CartBtn");
  const stock = card.querySelector("[data-variant-stock]");
  const realQty = card.querySelector(".real-qty");
  const price = card.querySelector("[data-variant-price]");
  const comparePrice = card.querySelector("[data-variant-compare-price]");
  const inventory = Number(option.dataset.inventory || 0);
  const cartQuantity = Number(option.dataset.cartQuantity || 0);
  const inventoryLimited = option.dataset.inventoryLimited === "true";
  const remaining = Math.max(inventory - cartQuantity, 0);
  const variantAvailable = String(option.dataset.available).toLowerCase() === "true";
  const available = variantAvailable && (!inventoryLimited || remaining > 0);

  if (variantId) variantId.value = option.value;
  if (form) {
    clearTimeout(form.cartFeedbackTimer);
    form.dataset.inventoryLimited = String(inventoryLimited);
    form.dataset.cartQuantity = String(cartQuantity);
  }
  if (price) price.textContent = option.dataset.price || "";
  if (comparePrice) {
    comparePrice.textContent = option.dataset.comparePrice || "";
    comparePrice.closest(".product-price").hidden = !option.dataset.comparePrice;
  }
  if (stock) stock.textContent = `庫存：${inventoryLimited ? remaining : inventory}`;
  if (realQty) realQty.textContent = inventoryLimited ? remaining : inventory;
  if (qtyInput) {
    if (inventoryLimited) qtyInput.max = Math.max(remaining, 1);
    else qtyInput.removeAttribute("max");
    qtyInput.min = available ? 1 : 0;
    qtyInput.value = available ? 1 : 0;
    qtyInput.disabled = !available;
  }
  card.querySelectorAll(".qty-btn").forEach(button => { button.disabled = !available; });
  if (addButton) {
    addButton.disabled = !available;
    addButton.classList.toggle("disable-CartBtn", !available);
    addButton.classList.toggle("CartBtn", available);
    const addButtonText = addButton.querySelector(".cartbtn-text");
    if (addButtonText) addButtonText.textContent = available ? "Add to Cart" : "Sold Out";
  }
}

document.addEventListener("change", function (event) {
  if (!event.target.matches(".variant-selector")) {
    return;
  }
  updateSelectedCardVariant(event.target);
});

function initializeSelectedCardVariants() {
  document.querySelectorAll(".collection-product-card .variant-selector").forEach(selector => {
    updateSelectedCardVariant(selector);
    selector.closest(".collection-product-card").setAttribute("data-variant-initialized", "true");
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeSelectedCardVariants);
} else {
  initializeSelectedCardVariants();
}

// Make initializeAddToCartForms available globally for sticky-cart.js
window.initializeAddToCartForms = initializeAddToCartForms;

document.addEventListener('DOMContentLoaded', function() {
    var labels = document.querySelectorAll('label[for^="Filter-"]');
    labels.forEach(function(label) {
        if (label.htmlFor.includes('availability-1')) {
            label.innerHTML = label.innerHTML.replace('In stock', '有存貨');
        } else if (label.htmlFor.includes('availability-2')) {
            label.innerHTML = label.innerHTML.replace('Out of stock', '無存貨');
        }
    });
});